import { render, staticRenderFns } from "./FooterButtonSizing.vue?vue&type=template&id=509a3160"
import script from "./FooterButtonSizing.vue?vue&type=script&lang=js"
export * from "./FooterButtonSizing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports